export type Episode = {
  id: string;
  number: number;
  title: string;
  summary: string;
  description: string;
  cover: string;
  duration: string;
  releaseDate: string;
  tags: string[];
};

export const episodes: Episode[] = [
  {
    id: "ep-01",
    number: 1,
    title: "初遇命运",
    summary: "连绵的春雨里，苏晚在旧书店屋檐下遇见了撑黑伞的顾时衍，一枚掉落的书签让两条平行线第一次相交。",
    description:
      "梅雨季节的临江市，苏晚为躲雨误入一间藏在巷子深处的旧书店，随手翻开的诗集里夹着一枚手写书签。就在她低头细读的瞬间，一把黑伞停在台阶外——书店的另一位常客顾时衍正是书签的主人。两人因这枚书签展开了一段关于诗歌与雨的交谈，彼此都不知道，这场偶遇早已被命运悄悄写好。本集用大量留白与雨声铺陈氛围，为全篇定下温柔而克制的基调。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20old%20bookstore%20entrance%20in%20the%20rain%2C%20two%20silhouettes%20under%20one%20black%20umbrella%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20gentle%20bokeh%20light%2C%20romantic%20cinematic%20mood%2C%20clean%20minimal%20composition&width=800&height=450&seq=sp-ep-01&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-04-05",
    tags: ["初遇", "日常", "温情"],
  },
  {
    id: "ep-02",
    number: 2,
    title: "甜蜜的陷阱",
    summary: "苏晚进入甜品店打工的第一天，发现常客里坐着那位黑伞少年，而他却装作从未见过她。",
    description:
      "为了攒下学费，苏晚应聘到街角新开的甜品店做兼职。开工第一天，她在靠窗的固定座位上再次看见顾时衍——对方只是淡淡点了杯美式，仿佛雨夜书店从未发生。苏晚一边手忙脚乱地学做舒芙蕾，一边忍不住偷偷观察他。甜点出炉的香气与刻意保持的距离感，让这段关系从第一集就埋下悬念：他究竟是真的忘了，还是在刻意回避。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20dessert%20cafe%20interior%20with%20a%20young%20woman%20working%20behind%20the%20counter%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20plates%20of%20pastries%2C%20gentle%20afternoon%20light%2C%20clean%20minimal%20composition&width=800&height=450&seq=sp-ep-02&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-04-12",
    tags: ["日常", "甜点", "心动"],
  },
  {
    id: "ep-03",
    number: 3,
    title: "心动的理由",
    summary: "一场突如其来的停电，让两人在满室烛光里第一次说出真心话，也让误会有了松动的缝隙。",
    description:
      "台风过境，老城区临时停电。甜品店里只剩下最后一位客人顾时衍和苏晚，两人在烛光下共处一室。苏晚无意间提起自己攒钱读书的梦想，顾时衍难得地讲起了他为何总是一个人。黑暗反而成了最好的掩护，那些白天说不出口的话一字一句地落下来。临近天明电力恢复，他却先一步离开，只留下一句'明天还来'。",
    cover:
      "https://readdy.ai/api/search-image?query=Candlelit%20cafe%20during%20a%20power%20outage%2C%20two%20people%20facing%20each%20other%20across%20a%20small%20table%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20glowing%20candles%2C%20intimate%20quiet%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-03&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-04-19",
    tags: ["心动", "夜晚", "真心话"],
  },
  {
    id: "ep-04",
    number: 4,
    title: "交错的心意",
    summary: "林小满的出现打破了微妙的平衡，她似乎比任何人都更了解顾时衍的过去。",
    description:
      "苏晚的室友林小满来店里探班，却与顾时衍像旧识般热络。原来小满中学时和顾时衍在同一场辩论赛上相识，知道一些苏晚从未听过的往事。她善意地提醒苏晚'那个人心里藏着事'，却又在无意间推动了两人之间的误会。本集通过小满这个活泼跳脱的视角，第一次让'过去'这个词进入了故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Three%20friends%20chatting%20around%20a%20dessert%20shop%20table%2C%20one%20cheerful%20girl%20leaning%20forward%20talking%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20friendly%20bustling%20mood%2C%20clean%20minimal%20composition&width=800&height=450&seq=sp-ep-04&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-04-26",
    tags: ["配角", "误会", "过往"],
  },
  {
    id: "ep-05",
    number: 5,
    title: "误解与距离",
    summary: "看到了不该看到的画面，苏晚选择了沉默退开，两个骄傲的人第一次真正错过。",
    description:
      "苏晚在顾时衍的公司楼下，看见他与沈氏集团的沈奕不欢而散。出于自卑，她把这一幕解读成'他们才属于同一个世界'，开始刻意与顾时衍保持距离。顾时衍察觉到了疏远，却用他惯有的沉默回应，两人之间的空气骤然冷了下来。本集用大量对比镜头呈现同一场雨，一个人在伞下，一个人在雨里。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20young%20woman%20standing%20alone%20in%20the%20rain%20looking%20away%2C%20a%20modern%20glass%20office%20tower%20in%20the%20blurred%20background%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20melancholic%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-05&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-05-03",
    tags: ["误会", "雨夜", "错过"],
  },
  {
    id: "ep-06",
    number: 6,
    title: "雨中告白",
    summary: "顾时衍在同样的雨夜里追上了苏晚，第一次没有用沉默，而是把伞和心意一起递了出去。",
    description:
      "苏晚淋着雨准备离开这座城市，顾时衍却在她上公交前赶到。这一次他没有再把话咽回去，而是把伞递给她，说清了自己所有的犹豫与在意。雨声盖住了他的声音，苏晚却听得格外清楚。两人在便利店屋檐下并肩站到天亮，这是全篇第一次真正的靠近，也是此后所有风波的起点。",
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20confession%20scene%20under%20a%20convenience%20store%20awning%20at%20night%2C%20a%20boy%20handing%20an%20umbrella%20to%20a%20girl%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20romantic%20glowing%20neon%2C%20clean%20composition&width=800&height=450&seq=sp-ep-06&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-05-10",
    tags: ["告白", "雨夜", "高能"],
  },
  {
    id: "ep-07",
    number: 7,
    title: "无法言说的秘密",
    summary: "陈默找上门来，苏晚第一次听说顾时衍家族那场改变一切的变故。",
    description:
      "顾时衍的助理陈默私下找到苏晚，希望她劝顾时衍别再独自硬扛。在他的讲述里，苏晚了解了顾家几年前的那场变故，以及顾时衍为何总把话藏在心里。同一时间，沈奕开始以合作为名频繁接近苏晚。陈默的忠诚与沈奕的算计在同一集里第一次正面对上，剧情的重心也由甜转酸。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20serious%20young%20man%20in%20a%20dim%20cafe%20explaining%20something%20to%20a%20listening%20girl%2C%20documents%20on%20the%20table%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20tense%20quiet%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-07&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-05-17",
    tags: ["秘密", "配角", "转折"],
  },
  {
    id: "ep-08",
    number: 8,
    title: "决裂的前夜",
    summary: "沈奕设下的局让苏晚成了'泄密者'，顾时衍不得不在亲情与信任之间做出选择。",
    description:
      "一场发布会上的资料泄露，所有证据都指向苏晚。沈奕站在一旁冷眼旁观，等着看顾时衍如何表态。顾时衍明知道真相，却因为更深的顾虑当众保持了沉默，这一沉默成了压在两人之间最重的一块石头。本集结尾，苏晚把工牌放在柜台上转身离开，是全篇第一个真正意义上的转折点。",
    cover:
      "https://readdy.ai/api/search-image?query=Tense%20business%20conference%20room%20scene%20with%20scattered%20documents%2C%20dramatic%20spotlight%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20confrontational%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-08&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-05-24",
    tags: ["冲突", "反派", "转折"],
  },
  {
    id: "ep-09",
    number: 9,
    title: "失去与重逢",
    summary: "分别之后，苏晚重新回到书店，而那枚手写书签再一次出现在她面前。",
    description:
      "离开临江的苏晚在外地重新开始，靠写作慢慢站稳脚跟。某个雨夜她走进陌生的旧书店，摊开的诗集里竟夹着一枚一模一样的书签——原来这些年顾时衍把想说的话都写进了诗里，一本一本地寄往她去过的每一座城市。本集以双线叙事呈现两人各自的成长，是全篇最安静也最让人心口发酸的一集。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20young%20woman%20holding%20a%20handwritten%20bookmark%20in%20a%20quiet%20bookstore%2C%20rain%20outside%20the%20window%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20nostalgic%20tender%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-09&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-05-31",
    tags: ["重逢", "成长", "催泪"],
  },
  {
    id: "ep-10",
    number: 10,
    title: "真相浮现",
    summary: "当年的资料泄露真相被揭开，沈奕的动机也随之浮出水面。",
    description:
      "韩雪主动交出了当年的备份文件，真相终于被摆上台面：泄密者另有其人，沈奕才是幕后推手，而他的动机源于更早的一场家族竞争。周亦然在关键时刻选择站在真相一边，让整个局面逆转。顾时衍第一次在公开场合为苏晚正名，可惜彼时两人早已隔着千里。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20dramatic%20reveal%20scene%20with%20a%20folder%20of%20documents%20opened%20under%20a%20desk%20lamp%2C%20hands%20and%20faces%20in%20shadow%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20mysterious%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-10&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-06-07",
    tags: ["真相", "反派", "反转"],
  },
  {
    id: "ep-11",
    number: 11,
    title: "最后的考验",
    summary: "面对最后一次抉择，顾时衍放下了掌控一切的习惯，把选择权交还给苏晚。",
    description:
      "风波平息，顾时衍找到苏晚，却没有立刻要求她回来，而是把自己这些年的信、书签和道歉一并交到她手上，让她自己决定。苏晚在旧书店重新翻到第一枚书签，想起了最初那个雨夜。本集是全篇情绪最满的一集，也是两人关系真正平等的开始——不再是拯救与被拯救，而是并肩。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20suitcase%20of%20old%20letters%20and%20bookmarks%20between%20two%20people%20on%20a%20rainy%20street%2C%20soft%20evening%20glow%2C%20warm%20orange%20and%20cream%20palette%2C%20stylized%20anime%20illustration%2C%20hopeful%20bittersweet%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-11&orientation=landscape",
    duration: "24 分钟",
    releaseDate: "2025-06-14",
    tags: ["抉择", "高能", "并肩"],
  },
  {
    id: "ep-12",
    number: 12,
    title: "甜蜜的结局",
    summary: "春雨再一次落下的那天，甜品店重新开门，柜台后站着两个人。",
    description:
      "故事的最后一集，苏晚回到临江，与林小满合开了当年那家甜品店。开张那天又下起了雨，顾时衍撑着那把旧黑伞走进来，把最后一句没说出口的话说完。店里的招牌换成了'甜蜜惩罚'——甜的是重逢，惩罚的是那些错过的年头。全剧在雨声、甜点香气与一句话的留白中温柔收尾。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20dessert%20shop%20reopening%20celebration%20scene%20with%20two%20people%20smiling%20behind%20the%20counter%2C%20rain%20outside%20the%20window%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20joyful%20tender%20mood%2C%20clean%20composition&width=800&height=450&seq=sp-ep-12&orientation=landscape",
    duration: "26 分钟",
    releaseDate: "2025-06-21",
    tags: ["结局", "重逢", "治愈"],
  },
];